var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ height: `${_vm.h / 16}rem`, width: `${_vm.w / 16}rem` })})
}
var staticRenderFns = []

export { render, staticRenderFns }